import { MutateOptions, useMutation } from '@tanstack/react-query';
import { UniversalChatThreadUpdateInput, UniversalChatThreadUpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = UniversalChatThreadUpdateInput;
type TData = UniversalChatThreadUpdatePayload;

export const useUniversalChatThreadUpdate = (
  options: MutateOptions<TData, TGenericError, TVariables, unknown> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation universalChatThreadUpdate($input: UniversalChatThreadUpdateInput!) {
      universalChatThreadUpdate(input: $input) {
        errors
        errorCode
        success
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    ...options,
    mutationFn: (input: TVariables) =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      })
  });
};
